import { RootState } from '../store'

const getMapDataDrawerState = (state:RootState) => state.app.mapDataDrawer.open


export const AppSelector = {
  getMapDataDrawerState,
}